import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { featuredFilms } from "@/mocks/content";
import { films } from "@/mocks/films";

export default function LatestFilms() {
  return (
    <section id="latest" className="py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <SectionHeading
              kicker="Latest"
              title="本周最新影片，先看这六部"
              desc="以下片子为本周新上或讨论度明显上升的代表，覆盖伦理片、韩剧、短剧与电影四类，方便你快速感受不同板块的调性。"
            />
            <p className="font-label text-xs text-foreground-500 shrink-0">
              更新时间：2026 年第 41 周
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-10 md:mt-12">
          {featuredFilms.map((item, i) => {
            const film = films.find((f) => f.id === item.filmId);
            return (
              <Reveal key={item.filmId} delay={i * 70}>
                <article
                  className="group h-full bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-colors"
                >
                  <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                    <img
                      src={item.poster}
                      alt={`${item.title} 主题海报插画`}
                      className="w-full h-full object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="absolute top-3 left-3 font-label text-[11px] px-2.5 py-1 rounded-md bg-background-50/90 text-primary-700">
                      {item.kicker}
                    </span>
                    <span className="absolute top-3 right-3 font-label text-xs px-2 py-1 rounded-md bg-foreground-950/70 text-background-50">
                      {film ? film.category : ""}
                    </span>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="font-heading text-lg font-bold text-foreground-950">
                        {item.title}
                      </h3>
                      <span className="font-heading text-lg font-bold text-accent-700 shrink-0">
                        {film ? film.score.toFixed(1) : ""}
                      </span>
                    </div>
                    <p className="text-sm leading-relaxed text-foreground-600 mt-2.5">{item.line}</p>
                    <div className="flex flex-wrap items-center gap-2 mt-4 font-label text-[11px] text-foreground-500">
                      <span>{film ? film.year : ""}</span>
                      <span className="w-1 h-1 rounded-full bg-background-300" aria-hidden="true" />
                      <span>{film ? film.region : ""}</span>
                      <span className="w-1 h-1 rounded-full bg-background-300" aria-hidden="true" />
                      <span>{film ? film.episodes : ""}</span>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}